import { InterestCheck } from './InterestCheck';
import { useInterests } from '@/hooks/useInterests';
import type { MovementSession } from '@/lib/yogaSessions';

export function YogaSessionCard({ session }: { session: MovementSession }) {
  const { hasInterest, toggleInterest } = useInterests();
  const checked = hasInterest(session.interestId);

  return (
    <div className="card" id={session.id} style={{ marginTop: 8 }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8 }}>
        <div style={{ minWidth: 0 }}>
          <div className={`intensity-badge intensity-badge--${session.intensity}`}>
            {session.intensityLabel}
          </div>
          <h2 style={{ fontSize: 16, margin: '6px 0 0' }}>{session.name}</h2>
          <p style={{ fontSize: 13, color: 'var(--color-ink-muted)', marginTop: 4 }}>
            {session.when}
            {' · '}
            {session.venue}
          </p>
          <p style={{ fontSize: 14, lineHeight: 1.5, marginTop: 6 }}>{session.summary}</p>
        </div>
        <InterestCheck
          checked={checked}
          label={session.name}
          onToggle={() => toggleInterest(session.interestId)}
        />
      </div>
      <p style={{ fontSize: 13, color: 'var(--color-ink-muted)', marginTop: 8, lineHeight: 1.45 }}>
        {session.address}
      </p>
      <ul style={{ fontSize: 14, lineHeight: 1.6, paddingLeft: 18, marginTop: 8 }}>
        {session.details.map((line) => (
          <li key={line.slice(0, 48)}>{line}</li>
        ))}
      </ul>
      <div className="action-row" style={{ marginTop: 10 }}>
        {session.phone && (
          <a className="action-btn" href={`tel:${session.phone}`}>
            Call {(session.phone === '2393967430' ? '(239) 396-7430' : session.phone)}
          </a>
        )}
        {session.href && (
          <a className="action-btn" href={session.href} target="_blank" rel="noreferrer">
            {session.phone ? 'Schedule' : 'Calendar / Rec1'}
          </a>
        )}
      </div>
      <p style={{ fontSize: 12, color: 'var(--color-ink-muted)', marginTop: 10, lineHeight: 1.45 }}>
        {session.sourceNote}
      </p>
    </div>
  );
}
